module.exports = __webpack_public_path__ + "img/37.9b47b6e.jpg";